import unreadPostsComponent from './unread-posts.component';

const unreadPostsModule = angular.module('unreadPosts', [
])
  .component('unreadPosts', unreadPostsComponent)
  .name;

export default unreadPostsModule;
